/**
 * Building template interface.
 * 
 * @todo Remove anys.
 * @todo @export
 *
 * @interface BuildingTemplate
 */
interface BuildingTemplate {

  /** Building template id. */
  _id: string;

  /** Current state. */
  active: true;

  /** Linked area templates, as an array of template id's. */
  areaTemplates: AreaTemplate['_id'][];

  /** Comments. */
  comments: any[];

  /** Creation date as ISO string. */
  created: string;

  /** Elements contained in building template, as an array of element id's. */
  elements: ProjectElement['_id'][];

  /** Additional info. May contain HTML. */
  info: string;

  /** Template language. */
  language: 'en' | 'nl';

  /** Logs. */
  logs: any[];

  /** Display name. */
  name: string;

  /** Last updated date as ISO string. */
  updated: string;

  __v: number;
};
